import { HttpHeaders, HttpClient } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { saveAs as importedSaveAs } from 'file-saver';
import { MxAlertService, MxBaseRestService } from 'mx-commons';
import { interval, Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { ModalUploadData } from 'src/app/model/analyse-credit';
import {
  IResponseDownload,
  UploadService,
} from 'src/app/shared/components/upload/upload.service';
import {
  getErrorMessageHttp,
  isNotNullAndUndefined,
  isNullOrUndefined,
} from 'src/app/shared/helpers/utils';
import { ConfigurationService, ILgpdDoc, IManual } from '../../configuration/configuration.service';
import { LoginService } from '../../login/login.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent implements OnInit, OnDestroy {
  isActive: boolean;
  collapsed: boolean;
  showMenu: string;
  pushRightClass = 'push-right';

  menus: Array<Menu> = [];
  rotaAtual = '';
  countWaitingMy = 0;
  countWaitingAll = 0;
  private intervalGetCount$: Subscription;

  data: ModalUploadData = null;
  lastManual:IManual = null;
  private readonly MANUAL_URL:string = "manual/";
  @Output()
  collapsedEvent = new EventEmitter<boolean>();
  colorCode: any = sessionStorage.getItem("colorMain")

  // webSocket: WebSocketAPI;

  constructor(
    private readonly uploadService: UploadService,
    public readonly router: Router,
    private readonly authService: LoginService,
    private readonly restService: MxBaseRestService,
    private readonly alertService: MxAlertService,
    private readonly configurationService: ConfigurationService,
    private readonly baseRest: MxBaseRestService,
    private readonly http: HttpClient

  ) {
    router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        if (window.innerWidth <= 992 && this.isToggled()) {
          this.toggleSidebar();
        }
        this.authService.rotaAtual.emit(val.url);
      }
    });

    authService.rotaAtual
      .pipe(distinctUntilChanged())
      .subscribe((url: string) => {
        this.rotaAtual = url;
        if (
          ['/', '/home', '/logout', '/alter-password', '/login'].includes(url)
        ) {
          return;
        }

        if (this.menus.length === 0) {
          this.montaMenus();
        }
        const menu = this.menus.find((m) => this.active(m));
        if (isNotNullAndUndefined(menu)) {
          if (authService.isPermissionAction(menu.actions)) {
            return;
          }
        } else if (
          url.startsWith('/analysecredit') &&
          url.length > '/analysecredit'.length
        ) {
          if (
            authService.isPermissionAction([
              'NewAnalyzeCredit',
              'ListAnalyzeCredit',
            ])
          ) {
            return;
          }
        }
        this.router.navigate(['/']);
      });

    // this.webSocket = new WebSocketAPI();
    // this.webSocket._connect();
  }

  async ngOnInit() {
    this.isActive = false;
    this.collapseSidebar(
      (sessionStorage.getItem('collapseSidebar') || 'false') === 'true'
    );
    this.showMenu = '';

    this.getNomeAndPermissoesUser();
  }

  ngOnDestroy() {
    this.menus = [];
    if (isNotNullAndUndefined(this.intervalGetCount$)) {
      this.intervalGetCount$.unsubscribe();
    }
  }

  toggleCollapsed() {
    this.collapseSidebar(!this.collapsed);
  }

  collapseSidebar(value: boolean) {
    this.collapsed = value;
    this.collapsedEvent.emit(this.collapsed);
    sessionStorage.setItem('collapseSidebar', this.collapsed.toString());
  }

  isToggled(): boolean {
    const dom: Element = document.querySelector('body');
    return dom.classList.contains(this.pushRightClass);
  }

  toggleSidebar() {
    const dom: any = document.querySelector('body');
    dom.classList.toggle(this.pushRightClass);
  }

  private addSeparadorMenu(menus: Array<Menu>): void {
    if (menus.length > 0) {
      menus.push(new Menu(null, null, null, null));
    }
  }

  private addItemMenu(
    menus: Array<Menu>,
    title: string,
    name: string,
    icon: string,
    url: string,
    acoes: Array<string>,
    queryParams?: any
  ): void {
    if (this.authService.isPermissionAction(acoes)) {
      menus.push(new Menu(title, name, icon, url, null, queryParams, acoes));
    }
  }

  private montaMenus() {
    this.menus = [];
    if ((this.authService.usuario.actions || []).length === 0) {
      return;
    }

    const menus = [];
    this.addItemMenu(
      menus,
      'analysecredit new',
      '/analysecredit',
      'fa fa-file-invoice-dollar',
      '/analysecredit',
      ['NewAnalyzeCredit']
    );
    this.addItemMenu(
      menus,
      'analisislist waiting my',
      '/analisislist/waitingMy',
      'fa fa-list',
      '/analisislist',
      ['WaitingMy'],
      { waitingMy: true }
    );
    this.addItemMenu(
      menus,
      'analisislist',
      '/analisislist',
      'fa fa-list',
      '/analisislist',
      ['ListAnalyzeCredit']
    );
    this.addSeparadorMenu(menus);

    this.addItemMenu(
      menus,
      'companies',
      '/companies',
      'fa fa-building',
      '/list/companies',
      ['KeepCompany']
    );
    this.addItemMenu(menus, 'users', '/users', 'fa fa-users', '/list/users', [
      'KeepUser',
    ]);
    this.addItemMenu(
      menus,
      'customers',
      '/customers',
      'fa fa-user',
      '/list/customers',
      ['KeepCustomer']
    );
    this.addSeparadorMenu(menus);

    this.addItemMenu(
      menus,
      'criteriongroups',
      '/criteriongroups',
      'fa fa-building',
      '/list/criteriongroups',
      ['KeepCriteriaGroup']
    );
    this.addItemMenu(
      menus,
      'productconfiguration',
      '/productconfiguration',
      'fa fa-building',
      '/list/productconfiguration',
      ['KeepProductConfiguration']
    );
    this.addItemMenu(
      menus,
      'user-permission',
      '/user-permission',
      'fa fa-id-card',
      '/user-permission',
      ['KeepProfileUser']
    );
    this.addItemMenu(
      menus,
      'configurations',
      '/configurations',
      'fa fa-cogs',
      '/configurations',
      ['KeepConfiguration']
    );
    this.addItemMenu(
      menus,
      'popup-notification',
      '/popup-notification',
      'fa fa-bell',
      '/list/popup-notification',
      ['KeepNotification']
    );
    this.addItemMenu(
      menus,
      'audit',
      '/audit',
      'fa fa-user-shield',
      '/list/audit',
      ['KeepAudit']
    );

    this.addItemMenu(menus, 'LGPD', '/lgpd', 'fa fa-paperclip', '/list/lgpd', [
      'KeepLgpd',
    ]);
    
    this.addItemMenu(menus, 'manual', '/manual', 'fa fa-book', '/list/manual', [
      'KeepManual',
    ]);

    this.menus = menus;
  }

  private async getNomeAndPermissoesUser() {
    const isAcesso = this.authService.usuario !== null;
    if (isAcesso) {
      if (this.menus.length === 0) {
        this.montaMenus();
      }
      //console.log("Primeiro load");
      await this.loadAguardandoFromApi();
      this.authService.onUserChange.emit();

      // 2min
      //console.log("Segundo load");
      this.intervalGetCount$ = interval(1000 * 30).subscribe((x) => {
        this.loadAguardandoFromApi();
      });
    } else {
      this.menus = [];
    }
  }

  go(menu: Menu): void {
    if (menu.title == 'LGPD') {
      this.downloadLgpd();
      return;
    }
    if(menu.title == 'manual') {
      this.downloadManual();
      return;
    }
    if (isNotNullAndUndefined(menu.queryParams)) {
      this.router.navigate([menu.url], { queryParams: menu.queryParams });
    } else {
      this.router.navigate([menu.url]);
    }

  }

  private async downloadLgpd() {
    //const url = `lgpd/lastdownload`;
    let res = await this.baseRest.getter(`lgpd/lastdownload`, '', '').toPromise() as ILgpdDoc;
    if(res != undefined){
      this.uploadService
        .download(`files/${res.attachment.attachmentId}`, {
          responseType: 'blob',
        })
        .subscribe(
          (response: IResponseDownload) => {
            if (response && response.blob) {
              importedSaveAs(response.blob, response.fileName);
              this.alertService.success(`Anexo baixado com sucesso.`);
            }
          },
          (error) => {
          }
        )
    }
  }
  private async downloadManual() {
    this.lastManual = null;
    try{
      await this.configurationService.getLastManual(this.MANUAL_URL + "last").then(res => {
        if (res)
          this.lastManual = res;
        else
          this.alertService.warning('Não há manual salvo no sistema!');
      });
      if(this.lastManual != null){
        await this.uploadService
          .download(`files/${this.lastManual.attachment.attachmentId}`, {
            responseType: 'blob',
          })
          .subscribe(
            (response: IResponseDownload) => {
              if (response && response.blob) {
                importedSaveAs(response.blob, response.fileName);
                this.alertService.success(`Manual baixado com sucesso.`);
              }
            },
            (error) => {
              this.alertService.error(`Erro ao baixar Manual.`);
            }
          )
      }
    }catch(error){
      console.log(error);
      this.alertService.error('Erro ao baixar manual.');
    }
  }

  active(menu: Menu): boolean {
    return (
      isNotNullAndUndefined(menu.url) &&
      ((this.rotaAtual === menu.url && isNullOrUndefined(menu.queryParams)) ||
        this.checkRotaActiveRotaAndQueryParams(menu))
    );
  }

  private checkRotaActiveRotaAndQueryParams(menu: Menu): boolean {
    if (this.rotaAtual.includes('?')) {
      if (
        isNotNullAndUndefined(menu.queryParams) &&
        this.rotaAtual ===
          menu.url + '?' + new URLSearchParams(menu.queryParams).toString()
      ) {
        return true;
      } else if (
        isNullOrUndefined(menu.queryParams) &&
        !this.menus.find(
          (m) =>
            isNotNullAndUndefined(m.queryParams) &&
            this.rotaAtual ===
              m.url + '?' + new URLSearchParams(m.queryParams).toString()
        )
      ) {
        const rota = this.rotaAtual.substring(0, this.rotaAtual.indexOf('?'));
        return menu.url === rota;
      }
    }
    return false;
  }

  private async loadAguardandoFromApi(): Promise<void> {
    if (this.menus) {
      const token = await localStorage.getItem('token');
      if (!isNullOrUndefined(token) && token !== 'null') {
        try {
          const count = await this.restService
            .getter('list-analysis-user/count/true', '', '')
            .toPromise();
          if (
            isNotNullAndUndefined(this.countWaitingMy) &&
            this.countWaitingMy > 0 &&
            this.countWaitingMy < count
          ) {
            this.alertService.warning(
              'Nova(s) análises aguardando o seu parecer.'
            );
          }
          this.countWaitingMy = count;
          this.countWaitingAll = await this.restService
            .getter('list-analysis-user/count/false', '', '')
            .toPromise();
        } catch (error) {
          console.log("Erro ao tentar contar as analises",error);
        }    
        const waitingMy = this.menus.find(
          (m) => m.name === '/analisislist/waitingMy'
        );
        if (isNotNullAndUndefined(waitingMy)) {
          waitingMy.count = this.countWaitingMy;
        }
  
        const waitingAll = this.menus.find((m) => m.name === '/analisislist');
        if (isNotNullAndUndefined(waitingAll)) {
          waitingAll.count = this.countWaitingAll;
        }
      }

    }
  }

  public getLastManual(): void {
		this.configurationService.getLastManual(this.MANUAL_URL + "last").then(res => {
			if (res)
				this.lastManual = res;
		});
	}
}

export class Menu {
  constructor(
    public title: string,
    public name: string,
    public icon: string,
    public url: string,
    public count?: number,
    public queryParams?: any,
    public actions?: Array<string>
  ) {}
}
